import React from "react";
import Image from "../../images/image";
import { getImageAltText } from "../../utils/manipulation";
import Link from "../../utils/link";

export default function SplitWithImageRelative({
  heading,
  description,
  primaryCtaText,
  primaryCtaLink,
  secondaryCtaText,
  secondaryCtaLink,
  image,
  bgClass,
  headerClass,
  category,
  isContentful
}) {

  return (
    <>
      <div className={bgClass}>
        <div className="w-full md:grid md:grid-cols-2">
          <div className="relative pb-11 pt-12 sm:pt-14 sm:pb-12 sm:text-center md:pt-16 lg:text-left grid place-items-center">
            <div className="px-0">
              {
                isContentful ? (
                  <>
                    <div className="text-sm font-medium bg-primary-700 text-white mb-3 border px-2 py-1 border-primary-700 rounded-3xl w-fit">
                      {category}
                    </div>
                  </>
                ) : (
                  <>
                    {
                      category && category.map((item, index) => (
                        <div key={index} className="text-sm font-medium bg-primary-700 text-white mb-3 border px-2 py-1 border-primary-700 rounded-3xl w-fit">
                          {item}
                        </div>
                      ))
                    }
                  </>
                )
              }

              <h1
                className={`tracking-tight font-bold text-gray-900 ${headerClass}`}
              >
                <span className="block">{heading}</span>
              </h1>
              <p
                className="mt-3 max-w-md sm:mx-auto text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl"
                dangerouslySetInnerHTML={{ __html: description }}
              />
              <div className="mt-5 sm:mt-10 flex flex-col space-y-4 sm:flex-row sm:space-x-4 sm:space-y-0 sm:justify-center lg:justify-start ">
                {primaryCtaLink && (
                  <Link
                    to={primaryCtaLink}
                    title={heading}
                    className="btn btn-primary btn-2xl w-full lg:w-auto"
                  >
                    {primaryCtaText}
                  </Link>
                )}
                {secondaryCtaLink && (
                  <Link
                    to={secondaryCtaLink}
                    title={heading}
                    className="btn btn-outline btn-2xl w-full lg:w-auto"
                  >
                    <span className="font-semibold">{secondaryCtaText}</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="flex h-full">
            <Image
              image={image}
              alt={getImageAltText(image)}
              className="m-auto w-full"
            />
          </div>
        </div>
      </div>
    </>
  );
}
